import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model';
import { DateHelperService } from '../../core/services';
import { LineChartOptions } from "../chart/line-chart-options.model";
import { WebWorkerService } from 'angular2-web-worker/web-worker.service';

@Component({
    moduleId: module.id,
    selector: 'yearly-revenue',
    templateUrl: 'yearly-revenue.component.html'
})
export class YearlyRevenueComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() showTopSectionOverlay: boolean;
    triggerChange: Date;
    chartValues: ChartValue[] = new Array<ChartValue>();
    chartOptions: LineChartOptions = new LineChartOptions();
    toolTipText: string = "{0} {1} ";

    constructor(
        private dateHelper: DateHelperService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit() {
        this.chartOptions.height = 100;
        this.chartOptions.xaxis = {
            mode: "time"
            , minTickSize: [1, "month"]
        };
        this.chartOptions.yaxis = { tickColor: "#494949", tickFormatter: this.chartOptions.getMonetaryShortFormat };
        this.chartOptions.formatTooltip = '1.2-2';
        this.chartOptions.tooltipCurrency = '$ ';
    }

    private mapAllData(): void {
        this.chartValues = new Array<ChartValue>();
        let chartValue = new ChartValue();
        for (let item of this.data.yearlyRevenues) {
            chartValue.data.push([this.dateHelper.getTicks(item.dateUtc), item.earning]);
            chartValue.lastItemIdentifier = item.dateUtc;
        }
        this.chartValues.push(chartValue);
    }

    private mapTodayData(params: any): void {
        Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return o; o++ } return -1 } }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return i; o++ } } });
        let todayValue = params.dataForToday.yearlyRevenues[0];
        if (todayValue) {
            let chartValue = params.chartValues.find(x => x.lastItemIdentifier == todayValue.dateUtc);
            if (chartValue) {
                let chartValueData = chartValue.data[chartValue.data.length - 1];
                chartValueData[1] = todayValue.earning;
            }
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
        if (this.dataForToday) {
            let params = {
                dataForToday: this.dataForToday,
                chartValues: this.chartValues
            }
            if (typeof (Worker) !== "undefined") {
                this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                    this.onMapTodayData(res);
                }).catch((r) => { console.log(r) });
            } else {
                let res = this.mapTodayData(params);
                this.onMapTodayData(res);
            }

        }
    }

    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.triggerChange = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/yearlyrevenue/yearly-revenue.component.ts